import React from "react";
import { darkTeams, noShadowTeams } from "../hooks/vars";
import teamsBasic from "../data/teamsBasic2025.json";
import { motion, AnimatePresence } from "framer-motion";
import { GetTeamStandingsConf, UseStandingsConf } from "../hooks/getStandings";

export function TeamRankCard(props) {
  //t=team key rank=rank record=record
  const teamData = teamsBasic.find((data) => data.Key === props.t);
  const darkTeam = darkTeams.includes(teamData.Key);

  return (
    <motion.div
      layout
      layoutId={"team-" + props.t}
      className="standingsRow"
      key={props.k}
      style={{
        //background: "#" + teamData.PrimaryColor,
        background:
          "linear-gradient(15deg,#000 -100%, #" +
          teamData.PrimaryColor +
          " 40%)",
        color:
          "#" + (!darkTeam ? teamData.SecondaryColor : teamData.TertiaryColor),
        textShadow: noShadowTeams.includes(teamData.Key)
          ? "1px 1px 0 #ffffff6c"
          : "2px 2px 0 #00000085",
      }}
      //initial={{ opacity: 0, y: 10 }}
      //animate={{ duration: 1, opacity: 1, y: 0 }}
      //exit={{ duration: 1, opacity: 0, y: -10 }}
      transition={{
        duration: 1,
        type: "spring",
        bounce: 0.5,
        mass: 5,
        damping: 25,
      }}
    >
      <div
        className="teamCardLogo"
        style={{
          backgroundImage: "url(" + teamData.WikipediaLogoURL + ")",
        }}
      ></div>
      <div className="confRank">{props.rank}</div>
      <div className="teamCardName">
        {teamData.Name} {darkTeam}
      </div>
      <div className="record">{props.record}</div>
    </motion.div>
  );
}

export function StandingsModule() {
  return (
    <>
      <div className="defaultModal standingsModule">
        <AnimatePresence>
          <div className="cont">
            <h3
              style={{
                gridColumnStart: 1,
                gridColumnEnd: 3,
              }}
            >
              LEAGUE STANDINGS
            </h3>
            <motion.div className="standingsColumn" layout>
              <h5>AFC</h5>

              <GetTeamStandingsConf c="AFC" />
            </motion.div>
            <motion.div className="standingsColumn" layout>
              <h5>NFC</h5>

              <GetTeamStandingsConf c="NFC" />
            </motion.div>
          </div>
        </AnimatePresence>{" "}
        <RefetchButton />
      </div>
    </>
  );
}

export function RefetchButton() {
  const { refetch } = UseStandingsConf();
  return (
    <>
      <button className="toggleButton refetchButton" onClick={refetch}>
        Refetch Standings
      </button>
    </>
  );
}

export function PlayoffModule() {
  const { data, isLoading, error } = UseStandingsConf();
  const [playoffSeeds, setPlayoffSeeds] = React.useState(null);

  // Extract top 7 seeds from each conference when data loads
  React.useEffect(() => {
    if (!data) return;

    let teamStandings = Object.values(data).slice(1, 2);
    teamStandings = teamStandings[0];

    const afcSeeds = teamStandings
      .filter((team) => team.conferenceAbv === "AFC")
      .slice(0, 7);

    const nflcSeeds = teamStandings
      .filter((team) => team.conferenceAbv === "NFC")
      .slice(0, 7);

    setPlayoffSeeds({
      AFC: afcSeeds,
      NFC: nflcSeeds,
    });
  }, [data]);

  if (isLoading) return <div>Loading playoff data...</div>;
  if (error) return <div>Error loading playoff data: {error.message}</div>;
  if (!playoffSeeds) return <div>No playoff data available</div>;

  return (
    <div className="defaultModal playoffModule">
      <h3>PLAYOFF PICTURE</h3>
      <div className="playoffContainer">
        <h4>AFC</h4>
        <div className="playoffConference">
          {playoffSeeds.AFC.map((team, i) => (
            <div key={team.teamAbv} className={"playoffSeed rank" + (i + 1)}>
              <TeamPlayoffCard
                key={team.teamAbv}
                k={i + 1}
                rank={i + 1}
                t={team.teamAbv}
              />
            </div>
          ))}
        </div>

        <h4>NFC</h4>
        <div className="playoffConference">
          {playoffSeeds.NFC.map((team, i) => (
            <div key={team.teamAbv} className={"playoffSeed rank" + (i + 1)}>
              <TeamPlayoffCard
                key={team.teamAbv}
                k={i + 1}
                rank={i + 1}
                t={team.teamAbv}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function TeamPlayoffCard(props) {
  //t=team key rank=rank record=record
  const teamData = teamsBasic.find((data) => data.Key === props.t);
  const darkTeam = darkTeams.includes(teamData.Key);

  return (
    <div
      layout
      className="standingsRow"
      key={props.k}
      style={{
        //background: "#" + teamData.PrimaryColor,
        background:
          "linear-gradient(15deg,#000 -100%, #" +
          teamData.PrimaryColor +
          " 40%)",
        color:
          "#" + (!darkTeam ? teamData.SecondaryColor : teamData.TertiaryColor),
        textShadow: noShadowTeams.includes(teamData.Key)
          ? "1px 1px 0px #ffffff6c"
          : "3px 3px 0 #000000a9",
      }}
      //initial={{ opacity: 0, y: 10 }}
      //animate={{ duration: 1, opacity: 1, y: 0 }}
      //exit={{ duration: 1, opacity: 0, y: -10 }}
      transition={{
        duration: 1,
        type: "spring",
        bounce: 0.5,
        mass: 5,
        damping: 25,
      }}
    >
      <div
        className="teamCardLogo"
        style={{
          backgroundImage: "url(" + teamData.WikipediaLogoURL + ")",
        }}
      ></div>
      <div className="confRank">{props.rank}</div>
      <div className="teamCardName">
        {teamData.Name} {darkTeam}
      </div>
      <div className="record">{props.record}</div>
    </div>
  );
}